import { createUseStyles } from "react-jss";
import type { Theme } from "../../../types/Theme";
import {
    MODERN_HYBRID_GRID_CELL_PADDING_PX,
    resolveModernGridEvenRowBackground,
    resolveModernGridSubHeaderColor,
} from "../../../theme/gridThemeTokens";

export default createUseStyles((theme: Theme) => ({
    gridItem: {
        composes: "grid__item",
        margin: 0,
        minWidth: theme.GridCellMinWidth,
        minHeight: theme.GridCellMinHeight,
        padding: ({ useModernHybridGridCellPadding }: { useModernHybridGridCellPadding?: boolean }) =>
            useModernHybridGridCellPadding ? MODERN_HYBRID_GRID_CELL_PADDING_PX : theme.GridCellPadding,
    },
    gridItemRunningTotal: {
        padding: 0,
    },
    gridItemAxisFill: {
        composes: "grid__item--axis-fill",
    },
    gridItemModernStriped: {
        // !important overrides legacy tableRow.ts cell/row fills injected with !important.
        backgroundColor: `${resolveModernGridEvenRowBackground()} !important`,
    },
    gridRowHeader: {
        composes: "grid__row-header",
        fontWeight: "normal",
        minWidth: 50,
        textAlign: "left",
    },
    gridRowHeaderRunningTotal: {
        minWidth: theme.UseModernTheme === true ? 100 : 50,
        ...(theme.UseModernTheme === true && {
            position: "relative",
            // Offset row header text to align with numeric input baseline in modern RT grid.
            top: 3,
        }),
    },
    gridColumnHeader: {
        composes: "grid__column-header",
        fontWeight: "normal",
        verticalAlign: "top",
    },
    gridChoiceHeader: {
        composes: "grid__choice-header",
        fontWeight: "bold",
        verticalAlign: "top",
    },
    gridHybridSubHeaderChoiceHeader: {
        composes: "grid-subheader-text",
        // !important overrides gridChoiceHeader bold/inherited colors on sub-header cells.
        color: `${resolveModernGridSubHeaderColor(theme)} !important`,
        fontWeight: "normal",
        "& *": {
            color: "inherit !important",
        },
    },
}));
